const API = 'api'
const V1 = 'v1'
const VERSION = `${API}/${V1}/version`
const MOCK_VERSION = 'http://www.mocky.io/v2/5e107c403500000f001e6959'
const ACUITY = 'https://www.acuityscheduling.com'
const KNOWLEDGE_CENTER = 'https://help.get-grin.com/'

export default {
  VERSION,
  MOCK_VERSION,
  ACUITY,
  KNOWLEDGE_CENTER
}
